module.exports = __webpack_public_path__ + "img/edge_activites_longue_randonnee.f3548816.svg";